import React, { useState, useEffect, useContext } from 'react';

import './CartButton.css';
import { storeId } from '../../../../../variables/Variables';
import { ukMKId, mexicoMKId,portugalMKId, polandMKId, lithuaniaMkId, moldovaMKId } from '../../../utils/StoreConfigManager';

const cartIcon = 'https://cdn.obsess-vr.com/add-to-bag-icon.png';
const wishlistIcon = 'https://cdn.obsess-vr.com/mary-kay/Heart.png';
const wishlistTextIcon = 'https://cdn.obsess-vr.com/mary-kay/WISH LIST.png';

// TODO: PASS IN CART PAGE URL, CART TEXT STYLE, AND CART TEXT AS PROPS
const CartButton = ({ onClick, text, itemCount }) => {
    return (
        <div className='cart-button-container flex-center hoverable' onClick={onClick}>
            <div className='cart-icon-container flex-center'>
                <img className='cart-icon' src={wishlistIcon} />
                {(itemCount > 0) && [ukMKId, mexicoMKId, portugalMKId, polandMKId, lithuaniaMkId, moldovaMKId].includes(storeId) && <span className='item-count'>{itemCount}</span>}
            </div>
            <div className='cart-icon-container flex-center'>
                <span className='cart-icon-text'>{text}</span>
            </div>
            {/* <span className='cart-button-text'>Wishlist</span> */}
        </div>
    )
}

export default CartButton;